import React from 'react';
import Button from '../../components/Button/Button';
import type { FilterTreeItem } from '../types';

interface ListViewFilterTreeLevelProps {
  items: FilterTreeItem[];
  onSelectItem: (item: FilterTreeItem) => void;
}

/* One level of the filter tree: the groups to drill into (marked with a ›) and
   the fields that can be filtered on */
const ListViewFilterTreeLevel = ({
  items,
  onSelectItem
}: ListViewFilterTreeLevelProps) => (
  <div>
    {items.map((item) => (
      <div key={item.kind === 'field' ? item.keyword : item.name}>
        <Button
          size="small"
          color="default"
          variant="text"
          onClick={() => onSelectItem(item)}
          dataAttributes={{ 'data-test-list-view-filter-item': item.name }}
        >
          {item.name}
          {item.kind === 'group' ? ' ›' : ''}
        </Button>
      </div>
    ))}
  </div>
);

export default ListViewFilterTreeLevel;
